export var getCommonParams = (restaurantBrandNameForAemApi, locationName, subLocationName) => {
  return {
    restaurant: restaurantBrandNameForAemApi,
    location: encodeURIComponent(locationName || ''),
    subLocation: encodeURIComponent(subLocationName || '')
  };
};